import instanceQuery from 'graphql/queries/nominal/NominalJournalTransactionQuery.graphql';
import fragment from 'graphql/fragments/nominal/PostedTransactionsFragment.graphql';

const NominalJournalTransactions = {
  type: 'PostedTransactionsResponse',
  formTitle: 'Posted Transactions',
  instance: instanceQuery,
  fragment,
};

export default NominalJournalTransactions;
